import styled from 'styled-components';
export const FlexGrow = styled.div.withConfig({
  displayName: "StyledComponents__FlexGrow",
  componentId: "zku2y4-0"
})(["flex-grow:1;"]);
export const FlexShrink = styled.div.withConfig({
  displayName: "StyledComponents__FlexShrink",
  componentId: "zku2y4-1"
})(["flex:1;word-break:normal;"]);
export const Flex = styled.div.withConfig({
  displayName: "StyledComponents__Flex",
  componentId: "zku2y4-2"
})(["display:flex;align-items:center;"]);
export const Small = styled.small.withConfig({
  displayName: "StyledComponents__Small",
  componentId: "zku2y4-3"
})(["display:block;line-height:16px;"]);